module.exports = __webpack_public_path__ + "static/media/layout8-img.78d3a641.svg";